import axios from 'axios';
import { AxiosResponse } from '../types';

// Create axios instance
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "https://api.optenics.com",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

// Log request headers for debugging
api.interceptors.request.use(
  (config) => {
    console.log('Request URL:', config.url);
    console.log('Request headers:', config.headers, 'Cookies:', document.cookie);
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    return Promise.reject(error);
  }
);

// Log response headers for debugging
api.interceptors.response.use(
  (response) => {
    console.log('Response headers:', response.headers);
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && error.config?.url?.endsWith('/auth/me')) {
      console.log('Interceptor: Suppressing 401 for /auth/me');
      return Promise.resolve(null);
    }
    console.error('API error:', error.response?.status, error.config?.url, error.response?.data);
    return Promise.reject(error);
  }
);

interface Api {
  get<T = any>(url: string, config?: any): Promise<AxiosResponse<T> | null>;
  post<T = any>(url: string, data?: any, config?: any): Promise<AxiosResponse<T>>;
}

export const login = async (email: string, password: string, rememberMe = false, appName = "Optenics") => {
  try {
    const response = await api.post<AxiosResponse<{ id: string; email: string; app_name: string }>>("/auth/login", {
      email,
      password,
      rememberMe,
      app_name: appName,
    });
    return response.data;
  } catch (error: any) {
    throw error;
  }
};

export const logout = async () => {
  try {
    await api.post("/auth/logout");
  } catch (err) {
    // Silent fail for logout
  }
};

export const getSession = async () => {
  try {
    const res = await api.get("/auth/me");
    console.log('getSession: Response from /auth/me:', res?.data);
    return res ? res.data : null;
  } catch (err: any) {
    console.error('getSession: Error:', err);
    return null;
  }
};

export default api as Api;
